import { ProductSubnav } from "../product/ProductSubnav";
import { ProductFAQ } from "../product/ProductFAQ";
import { AdviceEndCta } from "../info/AdviceBlocks";
import { InmetingReservering } from "../sections/InmetingReservering";
import { cityPath } from "../../lib/werkgebied";
import { CityHero } from "./CityHero";
import { CityIntro, CityLokaal, CityProducts, CityWijken, CityWoningen } from "./CitySections";
import { CityArticles, CityOthers, CityProjects, CityReviews, CityRoutes } from "./CityExtras";

export const cityCrumbs = (page) => [{ label: "Home", href: "/" }, { label: "Werkgebied", href: "/werkgebied" }, { label: page.name, href: cityPath(page.slug) }];

// Volledige plaatspagina; gedeeld door de openbare pagina en het voorbeeld in Beheer.
export const CityView = ({ page, faqs, offer }) => {
  const nav = [["over", "Over " + page.name], page.wijken?.length > 0 && ["wijken", "Wijken"], page.woningtypes?.length > 0 && ["woningen", "Woningen"],
    page.lokaal?.length > 0 && ["aandachtspunten", "Aandachtspunten"], ["producten", "Aanbod"], ["starten", "Starten"], faqs?.length > 0 && ["vragen", "Vragen"]].filter(Boolean);
  const params = { woonplaats: page.name };
  return (
    <div data-testid={`city-page-${page.slug}`}>
      <CityHero page={page} crumbs={cityCrumbs(page)} offer={offer} />
      <ProductSubnav items={nav} onderwerp={page.onderwerp} params={params} />
      <CityIntro page={page} />
      {page.wijken?.length > 0 && <CityWijken page={page} />}
      {page.woningtypes?.length > 0 && <CityWoningen page={page} />}
      {page.lokaal?.length > 0 && <CityLokaal page={page} />}
      <CityProducts page={page} />
      <CityRoutes page={page} />
      <CityProjects page={page} />
      <CityReviews page={page} />
      {page.show_inmeting && <InmetingReservering bron={cityPath(page.slug)} defaultWoonplaats={page.name} />}
      <ProductFAQ faqs={faqs} title={`Vragen over kozijnen in ${page.name}`} />
      <CityArticles page={page} />
      <CityOthers page={page} />
      <AdviceEndCta title={`Nieuwe kozijnen voor uw woning in ${page.name}?`} location="city" onderwerp={page.onderwerp} params={params} />
    </div>
  );
};
